import { Button } from "atoms";
import { useUpdateGalleryStatus } from "../api/useUpdateGalleryStatus";

type ProfileRevertButtonProps = { artistId: string };
function ProfileRevertButton({ artistId }: ProfileRevertButtonProps) {
  const { mutate } = useUpdateGalleryStatus();
  const revert = () => mutate({ artistId, betaProfile: undefined });
  return (
    <Button
      variant="blank"
      style={{ textTransform: "none" }}
      onClick={() => revert()}
    >
      ⚠ Revert Profile
    </Button>
  );
}

export { ProfileRevertButton };
